import { isCPAuthRoutePath } from '@clientportal/routing-layer/utils/auth-route.utils'

import type { SupportChatRouteLike, SupportChatSurfaceKey } from '../types/support-chat-permission.types'

const routeNameString = (name: SupportChatRouteLike['name']): string | null => (typeof name === 'string' ? name : null)

function isMembershipSurface(path: string, name: string | null): boolean {
  return path.startsWith('/courses') || path === '/courses' || Boolean(name?.startsWith('courses-'))
}

function isAffiliateSurface(path: string): boolean {
  return path === '/affiliates' || path.startsWith('/affiliates/')
}

function isCommunitiesSurface(path: string, name: string | null): boolean {
  return path.startsWith('/communities') || Boolean(name?.startsWith('communities-'))
}

/**
 * Maps the current clientportal route to a portal `chatWidgetSettings.permissions` key.
 * Order: auth (none) → `/courses` / courses-* → affiliates → communities → home.
 */
export function resolveSupportChatPermissionKey(route: SupportChatRouteLike): SupportChatSurfaceKey | null {
  const path = route.path || ''
  if (!path || isCPAuthRoutePath(path)) {
    return null
  }

  const name = routeNameString(route.name)
  if (isMembershipSurface(path, name)) {
    return 'membership'
  }
  if (isAffiliateSurface(path)) {
    return 'affiliate'
  }
  if (isCommunitiesSurface(path, name)) {
    return 'communities'
  }
  return 'home'
}
